import { Text } from '@byecode/ui'
import React from 'react'

import { TagIcon } from '@/components/TagIcon'

import * as CM from '../styles'
import * as SC from './styles'

interface SharedHeaderProps {
    title: string
    style?: React.CSSProperties
    onClose?: () => void
    onBack: () => void
}

export const SharedHeader: React.FunctionComponent<SharedHeaderProps> = ({ title, style, onBack, onClose }) => {
    return (
        <SC.Header style={style}>
            <TagIcon
                icon="ArrowLeftSmall"
                background="var(--color-gray-100)"
                size={28}
                radius={100}
                iconColor="var(--color-gray-400)"
                enableHover
                onClick={onBack}
                style={{ cursor: 'pointer' }}
            />
            <Text size={16} weight={500}>
                {title}
            </Text>
            {onClose ? (
                <TagIcon
                    icon="Close"
                    background="var(--color-gray-100)"
                    iconColor="var(--color-gray-400)"
                    size={28}
                    radius={100}
                    enableHover
                    onClick={onClose}
                    style={{ cursor: 'pointer' }}
                />
            ) : (
                <div style={{ width: 28 }} />
            )}
        </SC.Header>
    )
}
